import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getImageUrl } from '../utils';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
    ? '/api'
    : 'http://localhost:5000/api');

function OrderSuccess() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrder();
  }, [orderId]);

  const loadOrder = async () => {
    try {
      const response = await axios.get(`${API_URL}/orders/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error('Error loading order:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-page">Загрузка...</div>;
  }

  if (!order) {
    return <div className="loading-page">Заказ не найден</div>;
  }

  return (
    <div className="order-success-page">
      <div className="order-success-container">
        {/* Breadcrumbs */}
        <div className="breadcrumbs">
          <span onClick={() => navigate('/')} className="breadcrumb-link">Каталог</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Заказ №{order.orderNumber}</span>
        </div>

        {/* Success Header */}
        <div className="success-header">
          <div className="success-icon">✓</div>
          <h1>Заказ №{order.orderNumber} на сумму {order.totalAmount.toLocaleString()} ₽ создан</h1>
          <p className="success-message">
            Благодарим Вас за заказ! Мы свяжемся с вами в Telegram ({order.telegram}) для подтверждения.
          </p>
        </div>

        {/* Order Summary Card */}
        <div className="order-summary-card">
          <h3>Ваш заказ</h3>

          {order.items.map((item, index) => (
            <div key={index} className="order-item-summary">
              <div className="order-item-info">
                <h4>{item.name}</h4>
                <p>{item.price.toLocaleString()} ₽</p>
                <p>×{item.quantity}</p>
              </div>
              {item.productId?.image && (
                <div className="order-item-image">
                  {item.productId.image.startsWith('/') ? (
                    <img src={getImageUrl(item.productId.image)} alt={item.name} />
                  ) : (
                    <span>{item.productId.image}</span>
                  )}
                </div>
              )}
            </div>
          ))}

          <div className="order-total-summary">
            <span>Сумма заказа</span>
            <strong>{order.totalAmount.toLocaleString()} ₽</strong>
          </div>
        </div>

        {/* Order Details */}
        <div className="order-details-card">
          <h3>Детали доставки</h3>
          <div className="order-detail-row">
            <span>Получатель:</span>
            <strong>{order.customerName}</strong>
          </div>
          <div className="order-detail-row">
            <span>Telegram:</span>
            <strong>{order.telegram}</strong>
          </div>
          <div className="order-detail-row">
            <span>Город:</span>
            <strong>{order.city}</strong>
          </div>
          <div className="order-detail-row">
            <span>Адрес:</span>
            <strong>{order.address}</strong>
          </div>
          {order.wishes && (
            <div className="order-detail-row">
              <span>Пожелания:</span>
              <strong>{order.wishes}</strong>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="order-actions">
          <button onClick={() => navigate('/')} className="continue-shopping-button">
            Продолжить покупки
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccess;
